import React from 'react'

export default function RestrictedRiskAssessment() {
  return (
    <div>restricted-risk-assessment</div>
  )
}
